import React, { useState ,useEffect } from 'react';
import Select from 'react-select';
import './LoginPage.css';
import { Container, Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const countryOptions = [
    { value: '60', label: '+60', flag: 'my' },
    { value: '65', label: '+65', flag: 'sg' },
    // Add other countries as needed
];

const LoginPage = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(countryOptions[0]);
    const [authToken, setAuthToken] = useState('');
    const [isOtpPage, setIsOtpPage] = useState(false);
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [countdown, setCountdown] = useState(60); // Initial countdown set to 60 seconds
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [phoneError, setPhoneError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [otpAttempts, setOtpAttempts] = useState(5);
    const { t, i18n } = useTranslation();

    //useEffect(() => {
    //    let timer;
    //    if (countdown > 0) {
    //        setIsButtonDisabled(true);
    //        // Start the timer
    //        timer = setInterval(() => {
    //            setCountdown((prev) => prev - 1);
    //        }, 1000);
    //    } else {
    //        setIsButtonDisabled(false); // Enable the button when countdown reaches 0
    //    }

    //    // Cleanup the timer when component unmounts or countdown changes
    //    return () => clearInterval(timer);
    //}, [countdown]);

    //const requestAuthToken = async () => {
    //    try {

    //        //setCountdown(60);// added by Gautam to test Login attempt
    //        //setIsOtpPage(true);// added by Gautam to test Login attempt
    //        //setOtpAttempts(5);// added by Gautam to test Login attempt

    //        setOtpError('');
    //        const response = await fetch(`auth/otp/request?phoneNumber=${selectedCountry.value}${phoneNumber}`);
    //        if (response.ok) {
    //            const data = await response.json();

    //            const authCode = data?.data?.code;

    //            if (authCode) {
    //                setAuthToken(authCode);
    //                setCountdown(60);
    //                setIsOtpPage(true);
    //                setOtpAttempts(5);
    //            } else {
    //                // Handle scenario where auth code is missing in response
    //                setPhoneError("Something is wrong. Try again later");
    //                console.error("Auth code is missing in the response.");
    //            }
    //        } else {
    //            const data = await response;
    //            // Handle error scenario, such as a 4xx or 5xx status code
    //            const errorMessage = (await data.text()).toString();
    //            if (errorMessage.split(':')[1].toLowerCase().split(' ').join('') == 'notfound') {
    //                setPhoneError("Driver doesn't exist");
    //            } else { 
    //                setPhoneError(errorMessage);
    //            }
                
    //            console.error("Failed to request OTP. Status");
    //        }
    //    } catch (error) {
    //        // Catch any network or other errors
    //        setPhoneError("An unexpected error occurred while requesting OTP");
    //        console.error("An unexpected error occurred while requesting OTP");
    //    }
    //};
    const requestAuthToken = async () => {
        try {
            setOtpError('');
            setPhoneError('');

            console.log('🔍 Requesting OTP for:', selectedCountry.value + phoneNumber);

            const response = await fetch(`auth/otp/request?phoneNumber=${selectedCountry.value}${phoneNumber}`);
            console.log('📡 Response status:', response.status, 'OK:', response.ok);

            const data = await response.json();
            console.log(data);
            const authCode = data?.data?.code;
            console.log('🔑 Auth code:', authCode ? 'FOUND ✅' : 'MISSING ❌');
            if (response.ok) {
                //const data = await response.json();
                console.log('📦 Full response:', JSON.stringify(data, null, 2));
                console.log('📦 data.data:', data.data);
                console.log('📦 data?.data?.code:', data?.data?.code);

                const authCode = data?.data?.code;
                console.log('🔑 Auth code:', authCode ? 'FOUND ✅' : 'MISSING ❌');

                if (authCode) {
                    console.log('✅ Setting OTP page TRUE');
                    setAuthToken(authCode);
                    setCountdown(60);
                    setIsOtpPage(true);
                    setOtpAttempts(5);
                } else {
                    console.error("❌ Auth code missing:", data);
                    setPhoneError("Something is wrong. Try again later");
                }
            } else {
                const errorMessage = await response.text();
                console.error("❌ Error:", errorMessage);
                setPhoneError(errorMessage);
            }
        } catch (error) {
            console.error("❌ Exception:", error);
            setPhoneError("Error: " + error.message);
        }
    };

    const retryAuthToken = async () => {
        requestAuthToken();
        setCountdown(60);
        setOtp(new Array(6).fill(""));
    };

    const submitOtp = async () => {
        try {
            //window.location.href = "/"; // added by Gautam to test Login attempt
            setOtpError('');

            if (otpAttempts < 1) {
                setOtpError('You have exceeded the maximum number of attempts. Please request for a new OTP.');
                return 
            }
            const payload = {
                AuthCode: authToken,
                Otp: otp.join('')
            };
            const endpoint = `auth/otp/validate`;

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' // JSON content type
                },
                body: JSON.stringify(payload) // Convert the payload to JSON format
            });

            setOtpAttempts(prev => prev - 1);

            if (response.ok) {                
                console.log("OTP OK");
                if (window.location.pathname === "/login") {
                    // If the current path is "/login", redirect to home ("/")
                    window.location.href = "/";
                } else {
                    // Otherwise, refresh the current page
                    window.location.href = window.location.href;
                }
            } else {
                setOtpError(`Incorrect OTP. You have ${otpAttempts} attempts remaining. Please check and try again.`);
                console.error("Failed to request OTP. Status:", response.status);
            }
        } catch (error) {
            setOtpError("An error occurred while requesting OTP:", error);
            console.error("An error occurred while requesting OTP:", error);
        }
    };

    const handleOTPChange = (element, index) => {
        // Restrict non-numeric input
        if (isNaN(element.value)) return;

        // Update OTP value
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        // Move focus to the next input
        if (element.nextSibling && element.value) {
            element.nextSibling.focus();
        }
    };
    const handleOTPPaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text");

        // If the pasted content is a number and has the same length as OTP
        if (/^\d{6}$/.test(paste)) {
            const newOtp = paste.split("");
            setOtp(newOtp);

            // Focus the last input box
            document.querySelectorAll(".otp-input")[5].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        // Handle backspace key
        if (e.key === "Backspace" && otp[index] === "") {
            if (e.target.previousSibling) {
                e.target.previousSibling.focus();
            }
        }
    };
    const handlePhoneNumberChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9]/g, ''); // Only numbers
        if (value.startsWith('0')) {
            value = value.slice(1);
        }
        setPhoneNumber(value);
    };

    const formatOptionLabel = (option) => {
        return (
            <div className="margin5px min-width-30">
                <span className={`flag f-${option.flag} normal-flag`}></span>
                <span className="area-code">{option.label}</span>

            </div>
        );
    };

    const handleCountryChange = (selectedOption) => {
        setSelectedCountry(selectedOption);
    };

    const isPhoneNumberValid = phoneNumber.length >= 8;

    return (
        <div className="login-container">
            {!isOtpPage ? (
                // Login Page
                <>
                    <span className="login-header">{t('Login.Welcome')}</span>
                    <span className="login-header">{t('Login.Portal.Name')}</span>
                    <h4>{ t('Login.Secure')}</h4>
                    <p>{t('Login.Enter.Phone.No')}</p>
                    <div className="login-input">
                        <Select
                            className="country-select"
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            options={countryOptions}
                            isSearchable={false}
                            formatOptionLabel={formatOptionLabel}
                        />
                        <input
                            type="tel"
                            pattern="[0-9]*"
                            placeholder="12345678"
                            maxLength="16"
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                            className="phone-input"
                        />
                    </div>
                    {phoneError && <p style={{ color: '#f55538' }}>{phoneError}</p>}
                    <button className="login-button" disabled={!isPhoneNumberValid} onClick={requestAuthToken}>
                        <i className="fas fa-mobile-alt"></i> { t('Login.OTP.Button')}
                    </button>
                    <button className="login-button" disabled={true} >
                        <i className="fas fa-mobile-alt"></i> {t('Login.GrabAPP.Button')}
                    </button>
                </>
            ) : (
                // OTP Page
                <>
                        <h4>{ t('Login.Enter.OTP')}</h4>
                        <p>{t('Login.Enter.Phone.1')} +{selectedCountry.value + phoneNumber}. {t('Login.Enter.Phone.2')}.</p>
                        <div className="otp-container">
                            {otp.map((data, index) => (
                                <input
                                    key={index}
                                    type="tel"
                                    pattern="[0-9]*"
                                    maxLength="1"
                                    className="otp-input"
                                    value={data}
                                    onChange={e => handleOTPChange(e.target, index)}
                                    onKeyDown={e => handleKeyDown(e, index)}
                                    placeholder="•"
                                    onPaste={handleOTPPaste}
                                />
                            ))}
                            
                        </div>
                        {otpError && (
                            <div class="alert alert-danger mt-3" role="alert">
                                {otpError}
                            </div>
                        )}
                            <button className="login-button" disabled={otp.length !== 6} onClick={submitOtp}>
                            {t('Login.Submit.OTP')}
                        </button>
                        <button className="login-button" onClick={retryAuthToken} disabled={isButtonDisabled}>
                            {isButtonDisabled ? `Resend OTP in ${countdown} sec` : "Resend OTP"}
                        </button>
                        <div style={{ borderTop: "1px solid grey", margin: "3rem" }}></div>
                        <div className="text-center mt-3">
                            <p>{ t('Login.Didnt.Receive.OTP')}</p>
                            <Button color="secondary" onClick={() => window.location.assign('grabdriver://notifications')}>{ t('Login.Check.Inbox')}</Button>
                        </div>
                </>
            )}
        </div>
    );
}

export default LoginPage;